import React, { useState, useEffect } from "react"
import { Card, CardBody, Button, Container, Row, Col } from "reactstrap"
import pulaBazaarContent from "../../assets/images/users/pula_bazzaar_content.webp"
import pulaMarketContent from "../../assets/images/users/marketing-pula.webp"
import { Link, useNavigate } from "react-router-dom"
import ConfirmPopup from "components/ConfirmPopup"
import { useSelector, useDispatch } from "react-redux"
import { getDashboardDataRequest } from "../../redux/actions/auth"

const BazaarInfo = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)
  const pvs_cards = useSelector(state => state.auth.pvs_cards)
  const { dashboardData, dashboardLoading, dashboardError } = useSelector(
    state => state.auth
  )

  useEffect(() => {
    dispatch(getDashboardDataRequest())
  }, [])

  const updateMyDetails = () => {
    if (pvs_cards && pvs_cards.length > 0) {
      setIsConfirmOpen(false)
    } else {
      setIsConfirmOpen(true)
    }
  }

  return (
    <div className="page-content" style={{ paddingLeft: 0, paddingRight: 0 }}>
      <div className="container-fluid" style={{ padding: 0 }}>
        {dashboardData && dashboardData.active_bazaars && dashboardData.active_bazaars.length > 0 && (
          <div
            style={{
              width: "100%",
              // background: "linear-gradient(135deg, #f5f0f8 0%, #e8dff0 100%)",
              padding: "1.5rem 2rem",
            }}
          >
            <div className="pula-bazaar-card p-4 d-flex flex-column justify-content-center">
              <div className="d-flex justify-content-between align-items-start mb-3">
                <h2 className="pula-bazaar-title mb-0">
                  UPCOMING PULA BAZAARS
                </h2>
              </div>
              {dashboardData.active_bazaars.map(bazaar => (
                <div className="mb-4">
                  <h4 className="pula-bazaar-event-title mb-2">
                    {bazaar.bazaar_name }
                  </h4>

                  <h6 className="text-muted mb-2">{bazaar.description}</h6>
                </div>
              ))}

              <Button
                color="primary"
                className="btn-lg mt-2"
                onClick={() => navigate("/bazaar-interest-form")}
              >
                Update My Details <i className="mdi mdi-arrow-right ms-2"></i>
              </Button>
            </div>
          </div>
        )}

        <div className="justify-content-center p-5 h-100">
          <h3 className="h3 mb-4 nom-title">About PULA Bazaar</h3>

          <Row className="mb-4">
            <Col md={6}>
              <p
                style={{
                  color: "#7a6b8a",
                  fontSize: "1.05rem",
                  lineHeight: "1.8",
                }}
              >
                Every great business begins with a story. For many women, that
                story starts at a kitchen table, a late-night idea or a quiet
                dream of building something of their own. PULA Bazaar was
                created to give those stories a place to be seen, heard and
                supported. What began as a small initiative by PULA Pune Ladies
                has grown into a trusted marketplace where women entrepreneurs
                step forward with confidence and pride.
              </p>
              <p
                style={{
                  color: "#7a6b8a",
                  fontSize: "1.05rem",
                  lineHeight: "1.8",
                  marginBottom: "2rem",
                }}
              >
                At PULA Bazaar, sellers are not just stall owners. They are
                creators, risk-takers and builders. Week after week, the Bazaar
                brings together genuine buyers and passionate women-led brands,
                creating real connections, real feedback and real growth. The
                community trust that PULA has built over the years turns every
                Bazaar into an opportunity, not just a sale.
              </p>
            </Col>
            <Col md={6}>
              <img
                src={pulaMarketContent}
                alt="PULA Bazaar Event"
                className="img-fluid rounded"
                style={{ width: "100%", objectFit: "cover" }}
              />
            </Col>
          </Row>

          <p
            style={{
              color: "#7a6b8a",
              fontSize: "1.05rem",
              lineHeight: "1.8",
              marginBottom: "2rem",
            }}
          >
            More than a marketplace, PULA Bazaar is a movement. A space where
            women back women, businesses find momentum and ideas turn into
            sustainable livelihoods. Here, every product carries a story and
            every story deserves a platform.
          </p>
        </div>
      </div>
      <ConfirmPopup
        title="Unauthorized"
        isOpen={isConfirmOpen}
        message={
          "You need to be a PVS Member to proceed. Please become a PVS Member to proceed."
        }
        onConfirm={() => {
          navigate("/pvs-registration", { replace: true })
        }}
        confirmText="Become a PVS Member"
        cancelText="I'll do it later"
        toggle={() => {
          setIsConfirmOpen(!isConfirmOpen)
          navigate("/home", { replace: true })
        }}
      />
    </div>
  )
}

export default BazaarInfo
